export default __webpack_public_path__ + "static/eco-sustainability_bg-2-38c794d93cdd317a53b254f1c05fff92.svg";